import { Injectable } from "@angular/core";
import { Router } from '@angular/router'; 

import { IUser, User } from "./users/user";
import { Observable } from "rxjs/Observable";
import * as $ from 'jquery';
import { ApiEndPoints } from "./api.endpoints";

@Injectable()
export class AppCommonService{    
    public loadingLoader:boolean = false;
    public pageContentAdditionalClass = "";
    public pageName = "";
    public reDirectURL = "/home";
    public accountsMenuElement: HTMLElement;
    public loginMenuElement: HTMLElement;
    public amendCostCentreCardId: string = '';
    public showcontactFlag: boolean = true;
    public showLoginFlag: boolean = true;
    public logocenter: string = "";
    constructor(private router : Router)
    {
        
    }
    public showContact(): void {
      this.showcontactFlag = true;
    }

    public hideContact(): void {
      this.showcontactFlag = false;
    }
    public showLogin(): void {
      this.showLoginFlag = true;
    }

    public hideLogin(): void {
      this.showLoginFlag = false;
    }

    public showLogoCenter(): void {
      this.logocenter = "about-news-header";
    }

    public showLogoleft(): void {
      this.logocenter = "";
    }
    public showLoader():void{
        this.loadingLoader = true;
    }

    public hideLoader():void{
        this.loadingLoader = false;
    }

    public loadRequiredJS():void{
        $.getScript('assets/js/beyond.js');
        $.getScript('assets/js/custom.js');
    }

    public getCurrentUrl():string
    {        
        return this.router.url
    }

    public isHomePage():boolean
    {        
        var isHomePageCondition:boolean = false;        
        if(this.router.url === '/home' || this.router.url === '/')
        {
            isHomePageCondition = true;
        }
        return isHomePageCondition;
    }

    public isGenricPage(): boolean {
      var isGenricPageCondition: boolean = false;
      if (this.router.url === '/driversclub' || this.router.url === '/mybusinessadvantage' || this.router.url === '/myfleetsolutions' || this.router.url === '/myfuelcardaccount') {
        isGenricPageCondition = true;
      }
      if (this.router.url.toLowerCase().includes("/offer") || this.router.url.toLowerCase().includes("/drivingnews")){
        isGenricPageCondition = true;
      }
      return isGenricPageCondition;
    }

    public isNotOtherGenricPage(): boolean {
      var isNotOtherGenricPageCondition: boolean = false;
      if (this.router.url === '/accountdashboard' || this.router.url === '/my-business-advantage' || this.router.url === '/my-drivers-club' || this.router.url === '/my-fleet-solutions') {
        isNotOtherGenricPageCondition = true;
      }
      return isNotOtherGenricPageCondition;
    }

    public setAccountsMenuElement(el:HTMLElement)
    {
        this.accountsMenuElement = el;
    }

    public accountsMenuManualClick()
    {
      if (this.accountsMenuElement != null) {
        this.accountsMenuElement.click();        
      }        
    } 

    public setLoginMenuElement(el:HTMLElement)
    {
        this.loginMenuElement = el;
    }

    public loginMenuManualClick()
    {
        this.loginMenuElement.click();        
    }
}



// WEBPACK FOOTER //
// ./src/app/appcommon.service.ts